import { SETTINGS_SERVICE } from "@/services/settings.service.js";

const state = {getSettingsOutput: {}, putSettingsOutput: false};

const actions = {
    //Service to get settings
    getSettings({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('getSettingsRequest');

        SETTINGS_SERVICE.getSettings()
            .then(
                output => {
                    commit('getSettingsSuccess', output);
                },
                error => {
                    commit('getSettingsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update settings
    putSettings({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putSettingsRequest');

        SETTINGS_SERVICE.putSettings(input)
            .then(
                output => {
                    commit('putSettingsSuccess', output);
                },
                error => {
                    commit('putSettingsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getSettings
    getSettingsRequest(state) {
    },
    getSettingsSuccess(state, output) {
        state.getSettingsOutput = output;
    },
    getSettingsFailure(state) {
        state.getSettingsOutput = false;
    },

    //putSettings
    putSettingsRequest(state) {
        state.putSettingsOutput = null;
    },
    putSettingsSuccess(state, output) {
        state.putSettingsOutput = true;
    },
    putSettingsFailure(state) {
        state.putSettingsOutput = false;
    },
};

export const settings = {
    namespaced: true,
    state,
    actions,
    mutations
};